module.exports = "<div id=\"menu\">\r\n  <div class=\"container\">\r\n\r\n  </div>\r\n</div>\r\n<ng-template #load>\r\n  <div>loading ...</div>\r\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/menu/menu.component.html
// module id = Pc27
// module chunks = 7